import styled from 'styled-components'

import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

import Button from '../display/Button'
import LazyImage from '../display/LazyImage'
import { PlaceholderCardWrapper } from '../cards/PlaceholderCard'
import { BucketListButton as BaseBucketListButton } from '../cards/shared/styled'

export const Dates = styled.span`
  font-size: 12px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.labelGrey};
`

export const EscapeDetails = styled.div`
  ${typeStyle('-ds-font-lead-sm-light')}
  letter-spacing: 0.88px;
  color: #333333;
  margin-left: 12px;

  span {
    max-width: 20ch;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    ${media.md`
      max-width: 30ch;
    `}
  }
`

export const BookingItineraryButton = styled(BaseBucketListButton)<{
  filled: boolean
}>`
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    width: 30px;
    height: 30px;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.brand.jungle};
    background-color: ${({ theme, filled }) =>
      filled ? theme.brand.afterglow : theme.brand.sand};

    svg {
      height: 10px;
      width: 10px;
      color: ${({ theme }) => theme.brand.jungle};

      &:first-child {
        color: ${({ theme }) => theme.brand.jungle};
      }
    }
  }
`

export const BucketListButton = styled(BaseBucketListButton)<{
  isActive: boolean
}>`
  svg {
    color: ${({ theme }) => theme.brand.jungle};

    &:first-child {
      ${({ isActive, theme }) =>
        !isActive &&
        `
        color: ${theme.brand.sand};
      `}
    }
  }
`

export const BucketListPlaceholder = styled(PlaceholderCardWrapper)`
  background-color: lightgrey;
  border-radius: 6px;
`

export const BucketListDetailsPlaceholder = styled(PlaceholderCardWrapper)`
  background-color: lightgrey;
  border-radius: 6px;
`

export const EscapeRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 50px;

  ${media.md`
    height: 120px;
  `}

  ${LazyImage} {
    min-width: 80px;
    width: 80px;

    ${media.md`
      min-width: 200px;
      width: 200px;
    `}
  }

  ${EscapeDetails} {
    flex-grow: 1;
    height: 100%;
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  ${BaseBucketListButton} {
    height: 100%;
    right: -8px; /* to line up with "DONE" button */
  }

  ${BucketListPlaceholder} {
    height: 100%;
    width: 80px;

    ${media.md`
      width: 200px;
    `}
  }

  ${BucketListDetailsPlaceholder} {
    height: 20px;
    width: 200px;
    margin-left: 12px;
  }
`

export const Content = styled.div`
  h2 {
    text-transform: uppercase;
    font-size: 12px;
    color: #383838;
    margin: 12px 0 0 0;

    ${media.md`
      font-size: 16px;
    `}
  }

  ${EscapeRow} {
    margin-top: 12px;
  }
`

export const CreateNewBucketListButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  margin: 16px 0;

  svg {
    height: 15px;
    width: 15px;
    margin-right: 8px;
    margin-bottom: 1px;
  }
`
